import moment from 'moment';
import { Dispatch, SetStateAction } from 'react';
import { UseFieldArrayReturn, UseFormReturn } from 'react-hook-form';

import { DynamicTableCellConfig } from '~/legacy-components/LegacyDynamicFormTable/types';
import { getAttachmentUrl } from '~/utils/helper';

import { CompanyFormType, EmployeeFormType } from '../../SharedIndex';
import { IFormInput, RowData } from '../useForms';

export const readData = (
  empForms: EmployeeFormType[],
  companyForms: CompanyFormType[],
  empId: string,
) =>
  empForms &&
  empForms.map((doc) => {
    const EmployeeFormType = companyForms.find(
      (form) => form.fComFormId === doc.fEmpFormCompFormFK,
    );
    return [
      EmployeeFormType ? EmployeeFormType.fComFormName : '',
      moment(doc.fEmpFormCreatedTime).format('DD.MM.YYYY'),
      moment(doc.fEmpFormUpdatedTime).format('DD.MM.YYYY'),
      doc.fEmpFormAttachmentName
        ? {
            hrefLink: getAttachmentUrl(empId, doc.fEmpFormAttachmentId),
            name: doc.fEmpFormAttachmentName,
          }
        : '',
      doc.fEmpFormInfo ? doc.fEmpFormInfo : '',
      '',
    ];
  });

export const mappedData = (
  useFieldArrayMethods: UseFieldArrayReturn<IFormInput, 'form', 'id'>,
  useFormMethods: UseFormReturn<IFormInput>,
  setDeletedRows: Dispatch<SetStateAction<number[]>>,
  getCellConfig: (
    cellName: string,
    index: number,
    fEmpFormId: number,
    value?: string | number,
  ) => DynamicTableCellConfig,
) => {
  const { fields, remove } = useFieldArrayMethods;
  const { register, setValue } = useFormMethods;

  const editData: DynamicTableCellConfig[][] = fields.map((doc, index) => {
    const cellConfig = (cellName: string) =>
      getCellConfig(
        cellName,
        index,
        doc.fEmpFormId,
        (doc as RowData)[cellName] as string | number | undefined,
      );
    register(`form.${index}.fFormAttachment`);
    register(`form.${index}.fEmpFormAttachmentId`);
    setValue(`form.${index}.fEmpFormAttachmentId`, doc.fEmpFormAttachmentId);
    register(`form.${index}.fEmpFormId`);
    setValue(`form.${index}.fEmpFormId`, doc.fEmpFormId);
    return [
      { key: doc.id, ...cellConfig('fEmpFormCompFormFK') },
      {
        ...cellConfig('fEmpFormCreatedTime'),
      },
      {
        ...cellConfig('fEmpFormUpdatedTime'),
      },
      {
        ...cellConfig('fEmpFormAttachmentName'),
      },
      {
        ...cellConfig('fEmpFormInfo'),
      },
      {
        type: 'delete',
        width: '20px',
        onChange: (deleteIndex: number) => {
          remove(deleteIndex);
          if (doc && doc.fEmpFormId) {
            setDeletedRows((prevState) => [...prevState, doc.fEmpFormId || -1]);
          }
        },
      },
    ];
  });

  return {
    editData,
  };
};

export const mapDefaultData = (forms: EmployeeFormType[]): RowData[] =>
  forms.map((doc) => ({
    ...doc,
    fFormAttachment: undefined,
  }));
